export default function Saving() {
  return (
    <div className="flex h-screen justify-center items-center w-full flex-grow backdrop-blur bg-white bg-opacity-25 z-[100]">
      <div className="flex flex-col items-center">
        <div className="w-16 h-16 border-b-4 border-red-600 rounded-full animate-spin"></div>
        <div className="p-2 mt-4 font-semibold text-primary-blue tracking-[0.07rem]">
          SAVING
        </div>
      </div>
    </div>
  );
}
